"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _profile = require("@widget/profile");

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Merchant = _interopRequireDefault(require("./Merchant"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["onChange"];

function Merchants(_ref) {
  var onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var handleChange = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(merchantId) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onChange(merchantId);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleChange(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var merchants = (0, _reactRedux.useSelector)(_profile.selectAvailableMerchants);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": props['data-locator']
    }, merchants.map(function (merchant) {
      return /*#__PURE__*/_react["default"].createElement(_Merchant["default"], {
        key: merchant['id'],
        "data-locator": props['data-locator'] + '.' + merchant['id'],
        isActive: merchant['id'] === profile['merchant']['id'],
        onClick: function onClick() {
          return handleChange(merchant['id']);
        }
      }, merchant['name'] || merchant['email']);
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Merchants;
exports["default"] = _default;